import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/system'
import type { Theme } from '@mui/material/styles'
import { blue, grey, red, shade, yellow } from '../../colors'
import { Alert } from '@mui/material'

interface StyledBoxProps {
  theme?: Theme
}

export const SectionWrapper = styled(Box)<StyledBoxProps>(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  border: `1px solid ${shade[650]}`,
  borderRadius: theme.spacing(2),
  padding: theme.spacing(4),
  marginTop: 8
}))

export const OptionalLabel = styled(Typography)<StyledBoxProps>(({ theme }) => ({
  background: shade[750],
  width: 'fit-content',
  padding: `0 ${theme.spacing(2)}`,
  borderRadius: theme.spacing(2),
  color: grey[850],
  fontSize: '14px',
  fontWeight: 500,
  border: `1px solid ${shade[650]}`
}))

export const InvalidQuestionError = styled(Typography)<StyledBoxProps>(({ theme }) => ({
  background: red[50],
  width: 'fit-content',
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(4),
  padding: `${theme.spacing(1)}${theme.spacing(2)}`,
  borderRadius: theme.spacing(2),
  color: red[700],
  fontSize: '14px',
  fontWeight: 500,
  border: `1px solid ${red[100]}`
}))

export const InstructorAlert = styled(Alert)<StyledBoxProps>(({ theme }) => ({
  color: blue[500],
  fontWeight: 600,
  backgroundColor: shade[1],
  borderRadius: theme.spacing(4),
  border: `1px solid  ${blue[300]}`,
  alignItems: 'center'
}))
export const InstructorAttributeAlert = styled(Alert)<StyledBoxProps>(({ theme }) => ({
  color: '#0D121C',
  fontWeight: 600,
  backgroundColor: grey[750],
  borderRadius: theme.spacing(4),
  border: `1px solid  ${grey[350]}`,
  alignItems: 'center'
}))

/** Inline banner alerts (e.g. publish warnings); matches InstructorAttributeAlert shape with warning/yellow tones */
export const WarningBannerAlert = styled(Alert)<StyledBoxProps>(({ theme }) => ({
  color: grey[950],
  fontWeight: 600,
  backgroundColor: '#FFFAEB',
  borderRadius: theme.spacing(4),
  border: `1px solid ${yellow[100]}`,
  alignItems: 'flex-start',
  overflow: 'visible',
  '& .MuiAlert-icon': {
    alignItems: 'flex-start',
    paddingTop: theme.spacing(0.5)
  },
  '& .MuiAlert-message': {
    width: '100%',
    paddingTop: theme.spacing(0.25),
    overflow: 'visible'
  }
}))
